<template>
  <div>
    <TheHeader farming></TheHeader>
    <BreadcrumbBar/>
    <PageHeader>
      <TextHeading variant="subtitle" color="secondary">How we work</TextHeading>
      <TextHeading variant="lg">Backing British Farmers</TextHeading>
    </PageHeader>
    <PageGrid sidebar>
      <PageSide>
        <SideNav/>
      </PageSide>
      <PageMain>
        <div class="key-focus-areas">
          <CardReportHeader
            class="key-focus-areas__header"
            image="farming-by-numbers--farmer.png"
            farming
          >
            <TextHeading variant="subtitle" color="secondary">Our business in numbers</TextHeading>
            <TextHeading variant="lg" block>Direct from British Farmers</TextHeading>
          </CardReportHeader>
          <div class="key-focus-areas__wrapper">
            <CardReportBlocks
              farming
              quantity="1,000,000"
              details="Lorem ipsum dolor sit amet"
              image="farming-by-numbers--pig.png"
            />
            <CardReportBlocks
              farming
              quantity="700,000"
              details="Lorem ipsum dolor sit amet"
              image="farming-by-numbers--lamb.png"
            />
            <CardReportBlocks
              farming
              quantity="200,000"
              details="Lorem ipsum dolor sit amet"
              image="farming-by-numbers--cow.png"
            />
            <CardReportBlocks
              farming
              quantity="72,800,000"
              details="Lorem ipsum dolor sit amet"
              image="farming-by-numbers--hen.png"
            />
            <CardReportBlocks
              farming
              quantity="526,000,000"
              details="Lorem ipsum dolor sit amet"
              image="farming-by-numbers--eggs.png"
            />
            <CardReportBlocks
              farming
              quantity="758,000,000"
              details="Lorem ipsum dolor sit amet"
              image="farming-by-numbers--milk.png"
            />
          </div>
        </div>
      </PageMain>
    </PageGrid>
    <TheFooter></TheFooter>
  </div>
</template>

<script>
import PageMain from '../elements/PageMain.vue'
import TheFooter from '../components/TheFooter.vue'
import CardReportBlocks from '../components/CardReportBlocks.vue'
import CardReportHeader from '../components/CardReportHeader.vue'
import SideNav from '../components/SideNav.vue'
import PageSide from '../elements/PageSide.vue'
import PageGrid from '../elements/PageGrid.vue'
import TextHeading from '../elements/TextHeading.vue'
import PageHeader from '../components/PageHeader.vue'
import BreadcrumbBar from '../components/BreadcrumbBar.vue'
import TheHeader from '../components/TheHeader.vue'
export default {
  name: 'FarmingBusinessInNumbers',
  components: {
    TheHeader,
    BreadcrumbBar,
    PageHeader,
    TextHeading,
    PageGrid,
    PageSide,
    SideNav,
    CardReportHeader,
    CardReportBlocks,
    TheFooter,
    PageMain
  },
  methods: {
    handleClick(url) {
      window.location.href = url
    }
  }
}
</script>
<style lang="postcss">
.key-focus-areas {
  @apply flex flex-wrap mt-8 mb-6;
}
.key-focus-areas__header {
  @apply w-full;
}
.key-focus-areas__wrapper {
  @apply flex justify-start items-stretch -mt-16 -mx-6 overflow-scroll scrolling-touch;
}
.cr-report-header--farming + .key-focus-areas__wrapper {
  @apply -mt-24;
}
@screen md {
  .key-focus-areas__wrapper {
    @apply flex-wrap justify-center mx-0 overflow-visible mb-8;
  }
}
@screen lg {
  .key-focus-areas {
    @apply pl-8 -ml-2/12 mt-0 mb-8;
  }
  .key-focus-areas__wrapper {
    @apply -mx-4;
    width: calc(100% + 2rem);
  }
}
</style>

